export default class InstanceJustificationAdd {
  justificationId: string;

  observation: string;

  constructor(obj: any = {}) {
    this.justificationId = obj.justificationId || '';
    this.observation = obj.observation || '';
  }
}
